import { AppContext } from "common/context/WithAppWrapper"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { SIGN_UP } from "routes/RoutePaths"

const NavBarNotRegistred = ({ hideRegis }: { hideRegis: boolean }) => {
  const { t } = useTranslation()
  const history = useHistory()
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)

  return (
    <div className='tw-flex tw-w-full tw-justify-evenly tw-items-center tw-min-h-[64px]'>
      <img
        src={settings.mainLogo}
        alt='logo'
        className='tw-w-36 tw-h-6'
      />

      {!hideRegis && (
        <button
          onClick={() => history.push(SIGN_UP)}
          type='button'
          className='tw-flex tw-justify-center tw-items-center !tw-bg-secondary hover:!tw-bg-secondary-over tw-px-6 tw-py-2 tw-text-white tw-rounded '
        >
          {t("header.registrarme")}
        </button>
      )}
    </div>
  )
}

export default NavBarNotRegistred
